var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amplify__wrapper"},[_c('amplify-authenticator',[_c('amplify-sign-in',{attrs:{"slot":"sign-in"},slot:"sign-in"},[_c('div',{attrs:{"slot":"federated-buttons"},slot:"federated-buttons"})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }